import styled from 'styled-components';

export const TopPanelWrapper = styled.div`
  margin-bottom: 2.5px;
  position: relative;
  background-color: #fff;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  font-size: 1.5em;
  text-align: left;
  margin-left: 0.4em;
  margin-top: 1em;
`;

export const ConfigWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
  overflow-y: hidden;
`;

export const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
`;

export const SummaryWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  & > * {
    margin: 10px;
  }
`;

export const ShareWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

export const TabRow = styled.div`
  position: relative;
  width: 100%;
  height: 30px;
`;

export const RightTopBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
